import { render } from "./StripePaymentForm.vue?vue&type=template&id=70c64c0f"
import script from "./StripePaymentForm.vue?vue&type=script&lang=js"
export * from "./StripePaymentForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__